import { ParsedUrlQuery } from 'querystring';

export const queryObjectToString = (query: ParsedUrlQuery): string => {
  const urlSearchParams = new URLSearchParams();

  for (const key in query) {
    if (key === 'tab') {
      continue;
    }

    const value = query[key];

    if (typeof value === 'string') {
      urlSearchParams.set(key, value);
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => {
        urlSearchParams.set(`${key}[${index}]`, item);
      });
    }
  }

  return urlSearchParams.toString();
};
